import { formatMoney as formatAsMoney } from '@shopify/theme-currency';

/** @typedef {string} ISOCode */

/**
 * @typedef {{
 *  name: string;
 *  isoCode: ISOCode;
 *  symbol: string;
 * }} Currency
 */

/**
 * @typedef {{
 *  moneyFormat: string;
 * }} MoneyConfig
 */

/** @type {{ money: MoneyConfig }} */
const { money } = window.settings;

const { moneyFormat } = money;

const formatMoney = (price, format = moneyFormat) =>
  formatAsMoney(price, format);

export default formatMoney;
